module.exports = __webpack_public_path__ + "static/media/es.ad238241.svg";